import { withTranslation } from "react-i18next";
import withRouter from "../../../../components/Common/withRouter";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createSelector } from "reselect";
import { Link } from "react-router-dom";
import GlobalLoader from "../../../../components/Common/GlobalLoader";

import BreadCrumb from "../../../../components/Common/BreadCrumb";
import TableContainerWarehouse from "../../../../components/Common/TableContainerWarehouse";
import {
  loadDeductionCategories as onLoadDeductionCategories,
  deleteDeductionCategory as onDeleteDeductionCategory
} from "../../../../slice/payroll/thunks";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { toast } from "react-toastify";


const DeductionCategories = (props) => {

    const dispatch = useDispatch()
    const [isLoading, setIsLoading] = useState(true)

    // States pour la suppression
      const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
      const [isDeleted, setIsDeleted] = useState(false);
      const [deductionCategoryToDelete, setDeductionCategoryToDelete] = useState(null);

    const selectLayoutState = (state) => state.Payroll;
    const PayrollProperties = createSelector(
      selectLayoutState,
      (payroll) =>({
        deductionCategories: payroll?.deductionCategories ?? [],
        error: payroll?.error ?? null
      })
    )

    const {deductionCategories, error } = useSelector(PayrollProperties)

    const loadDeductionCategories = useCallback((page, size) => {
        dispatch(onLoadDeductionCategories({page: page, size: size}))
        .then(() => {
            setIsLoading(false);
        });
    } , [dispatch]);

    const confirmDelete = useCallback(() => {
        if (!deductionCategoryToDelete) return;
        dispatch(onDeleteDeductionCategory(deductionCategoryToDelete.id))
        .unwrap()
        .then((response) => {
          setIsDeleteModalOpen(false);
          setIsDeleted(true);
          toast.success(response.message);
          loadDeductionCategories();
        }).catch((error) => {
          setIsDeleteModalOpen(false);
          loadDeductionCategories();
          toast.error(error.message || "Failed to delete deduction category");
        });
      },[dispatch, deductionCategoryToDelete, setIsDeleteModalOpen, setIsDeleted, loadDeductionCategories]);



    const handleDeleteClick = (rowData) => {
        setDeductionCategoryToDelete(rowData);
        setIsDeleteModalOpen(true);
    }

    useEffect(() => {
        loadDeductionCategories();
    }, [dispatch]);


    const columns = useMemo(
        () => [
          {
            header: props.t("no"),
            style: "button",
            enableColumnFilter: false,
            cell: (cellProps) => {
              return <span>
                  {deductionCategories && deductionCategories.page === 1 ?
                    (cellProps.row.index + 1)
                    : (((deductionCategories && deductionCategories.page-1)*10)+cellProps.row.index + 1) }
              </span>;
            },
          },
          {
            header: props.t("deduction_category_name"),
            accessorKey: "name",
            style: "button",
            enableColumnFilter: false,
            sortable: false,
          },
          {
            header: props.t("deduction_category_rank"),
            accessorKey: "position",
            style: "button",
            enableColumnFilter: false,
            sortable: false,
          },
          {
            header: props.t("action"),
            style: "text-end",
            cell: (cellProps) => {
              return (
                <div className="d-flex justify-content-end">
                    <ul className="list-inline hstack mb-0">
                      <li className="list-inline-item edit" title="Edit">
                        <Link
                          to={`/payroll/deduction-categories/${cellProps.row.original.id}/edit`}
                          className="text-primary d-inline-block edit-item-btn"
                        >
                          <i className="fa fa-pencil" aria-hidden="true"></i>
                        </Link>
                      </li>
                      <li className="list-inline-item" title="Remove">
                        <Link
                          to="#"
                          className="text-danger d-inline-block remove-item-btn"
                          onClick={() => handleDeleteClick(cellProps.row.original)}
                        >
                          <i className="fa fa-trash" aria-hidden="true"></i>
                        </Link>
                      </li>
                    </ul>
                </div>
              );
            },
          },
        ]
    );

    return (
        <React.Fragment>
            {isLoading ?
              <GlobalLoader />
                :
                <>
              {/* <DeleteModal show={deleteModal} onDeleteClick={handleDeleteBeds} onCloseClick={() =>setDeleteModal(false)} /> */}
                  <div className="deduction-categories px-3">
                    <div className="patients-list py-4 px-2  ">
                      <div className="container-fluid">
                        <div className="row list-patients d-flex  justify-content-between">
                          <Link to="/payroll/setting" className="col-lg-5">
                            <BreadCrumb title={props.t("payroll_settings")} pageTitle={props.t("deduction_categories")} />
                          </Link>
                          <div className="col-sm-auto new-mode-btn">
                            <Link to="/payroll/deduction-categories/add" className="btn btn-std mx-2" >
                              <i className="fas fa-user-md mx-1"></i>
                                {props.t("add_new_category")}
                            </Link>
                            </div>
                        </div>

                        <div className="deduction-categories">
                          <div className="container-fluid">
                            <div className="row justify-content-between">
                              <div className="card table-card">
                                <TableContainerWarehouse
                                  columns={columns}
                                  data={deductionCategories?.items ?? []}
                                  customPageSize={10}
                                  tableSize={ deductionCategories && deductionCategories.size }
                                  tablePage={ deductionCategories && deductionCategories.page }
                                  tableTotal= { deductionCategories && deductionCategories.total_items }
                                  tableTotalPage= { deductionCategories && deductionCategories.total_page }
                                  onNextPage= {loadDeductionCategories}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>


                {/* Modal Confirmation Delete */}
                <Modal
                  isOpen={isDeleteModalOpen}
                  toggle={() => setIsDeleteModalOpen(!isDeleteModalOpen)}
                  centered
                >
                  <ModalHeader toggle={() => setIsDeleteModalOpen(false)}>
                    {props.t("confirm_delete")}
                  </ModalHeader>
                  <ModalBody>
                    {props.t("are_you_sure_delete")}{" "}
                    <strong>{deductionCategoryToDelete?.name}</strong> ?
                  </ModalBody>
                  <ModalFooter>
                    <Button color="danger" onClick={confirmDelete}>
                      {props.t("delete")}
                    </Button>
                    <Button color="secondary" onClick={() => setIsDeleteModalOpen(false)}>
                      {props.t("cancel")}
                    </Button>
                  </ModalFooter>
                </Modal>
                </>
            }
        </React.Fragment>
    )
};

export default withRouter(withTranslation()(DeductionCategories))